import React from 'react';
import PropTypes from 'prop-types';

import { TimedProgress } from '../../components/TimedProgress';
import { withCountdown } from '../../hocs/withCountdown';

const TimedProgressContainer = ({
  timedProgressLeftDescription = 'Your security',
  timedProgressRightDescription = 'Time left to complete',
  currentQuestion,
  totalQuestions,
  timeRemaining
}) => (
  <TimedProgress
    left={{
      desc: timedProgressLeftDescription,
      title: updateStatus(currentQuestion, totalQuestions)
    }}
    right={{
      desc: timedProgressRightDescription,
      title: updateTimeStatus(timeRemaining)
    }}
  />
);

TimedProgressContainer.propTypes = {
  content: PropTypes.object.isRequired
};

const SECS_IN_MIN = 60;

const updateStatus = (currentQuestion, totalQuestions) => {
  return `Question ${currentQuestion} of ${totalQuestions}`;
};

const updateTimeStatus = timeRemaining => {
  const mins = Math.floor(timeRemaining / SECS_IN_MIN);
  const secs = timeRemaining % SECS_IN_MIN;
  return `${mins}m ${secs}s`;
};

const ConnectedTimedProgressContainer = withCountdown()(TimedProgressContainer);

export { ConnectedTimedProgressContainer as TimedProgressContainer };
